import moment from "moment/moment";
import React from "react";
import { useDrag } from "react-dnd";
import lightenDarkenColor from "../../utils/lightenDarkenColor";
import Delete from "../../assets/delete.svg";
import { useDeleteProjectMutation } from "../../redux/features/projects/projectsApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { filterSelector } from "../../redux/features/filter/filterSlice";
import useAuth from "../../hooks/useAuth";

function SingleProject({ projectState, project }) {
  const serchTerm = useSelector(filterSelector);
  const { user } = useAuth();

  let isMatched =
    project.projectDescription
      .toLowerCase()
      .includes(serchTerm.toLowerCase()) && serchTerm !== "";

  const [open, setOpen] = React.useState(false);
  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: "card",
    item: { project: project },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  const [deleteProject] = useDeleteProjectMutation();

  const handleDelete = async (id) => {
    if (user.email !== project.projectCreator.email) {
      toast.warning("You are not authorized to delete");
    } else {
      try {
        await deleteProject(id).unwrap();
        toast.success("Project has been deleted successfully");
      } catch (error) {
        toast.error("Something went wrong");
      }
    }
  };

  return (
    // <div className="p-2 bg-yellow-100 flex justify-start items-center ">
    <div
      className={`relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100 ${
        isMatched ? `border-red-300 border-2 bg-fuchsia-100 animate-pulse` : ``
      }`}
      ref={dragRef}
      draggable={true}
      style={{ border: isDragging ? "2px solid rgb(236 72 153)" : "" }}
    >
      {projectState === "BackLog" && (
        <>
          <button
            className="absolute top-0 right-0 flex items-center justify-center  w-5 h-5 mt-3 mr-2 text-gray-500 rounded hover:bg-gray-200 hover:text-gray-700 group-hover:flex"
            onClick={() => setOpen(!open)}
          >
            <svg
              className="w-4 h-4 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
            </svg>
          </button>
          {open ? (
            <div
              className="absolute z-10 top-8 right-2 bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700"
              onClick={() => handleDelete(project.id)}
            >
              <div className="block p-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                <img className="w-4 h-4" alt="Delete" src={Delete} />
              </div>
            </div>
          ) : null}
        </>
      )}
      <span
        style={{
          background: project.team.teamColor,
          color: lightenDarkenColor(project.team.teamColor, -80),
        }}
        className="flex items-center h-6 px-3 text-xs font-semibold rounded-full"
      >
        {project.team.teamName}
      </span>
      <h4 className="mt-3 text-sm font-medium">{project.projectDescription}</h4>
      <div className="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
        <div className="flex items-center">
          <svg
            className="w-4 h-4 text-gray-300 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
              clipRule="evenodd"
            />
          </svg>
          <span className="ml-1 leading-none">
            {moment(project.timeStamp).format("Do MMM")}
          </span>
        </div>

        <img
          className="w-6 h-6 ml-auto rounded-full"
          src={project.projectCreator.userUrl}
        />
      </div>
    </div>
  );
}

export default SingleProject;
